import type { Record } from "@suse-o11y/record";
import React from "react";

import type { ObservabilityPromQLVariable } from "../../routes/dashboards/built-in-variables";

export const OBSERVABILITY_PROMQL_VARIABLE_TO_DESCRIPTION = {
	__interval: (
		<p>
			Use the <code>$&#123;__interval&#125;</code> variable as the range for aggregations over time instead of
			hard-coded time intervals. It will automatically adjust to the selected time-range
		</p>
	),

	__rate_interval: (
		<p>
			Use the <code>$&#123;__rate_interval&#125;</code> parameter as the range for rate aggregations like{" "}
			<code>rate</code>, <code>increase</code> etc. It will also automatically adjust with the seleted time-range, but
			it is typically twice as long as the <code>__interval</code> to make it work better with rate-like PromQL
			functions, for example making it more resilient to a lost data point
		</p>
	),
} satisfies Record<ObservabilityPromQLVariable>;
